import { render, staticRenderFns } from "./managerChange.vue?vue&type=template&id=4967b08c&scoped=true&"
import script from "./managerChange.vue?vue&type=script&lang=js&"
export * from "./managerChange.vue?vue&type=script&lang=js&"
import style0 from "./managerChange.vue?vue&type=style&index=0&id=4967b08c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4967b08c",
  null
  
)

export default component.exports